<script setup lang="ts"></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 74 74"
    fill="none"
  >
    <circle
      cx="47"
      cy="27"
      r="11"
      fill="black"
    ></circle>
    <circle
      cx="27"
      cy="6"
      r="6"
      fill="black"
    ></circle>
    <circle
      cx="47"
      cy="6"
      r="4"
      fill="black"
    ></circle>
    <circle
      cx="6"
      cy="27"
      r="4"
      fill="black"
    ></circle>
    <circle
      cx="27"
      cy="68"
      r="4"
      fill="black"
    ></circle>
    <circle
      cx="68"
      cy="47"
      r="4"
      fill="black"
    ></circle>
    <circle
      cx="6"
      cy="6"
      r="3"
      fill="black"
    ></circle>
    <circle
      cx="6"
      cy="68"
      r="3"
      fill="black"
    ></circle>
    <circle
      cx="68"
      cy="68"
      r="3"
      fill="black"
    ></circle>
    <circle
      cx="68"
      cy="6"
      r="3"
      fill="black"
    ></circle>
    <circle
      cx="47"
      cy="68"
      r="6"
      fill="black"
    ></circle>
    <circle
      cx="68"
      cy="27"
      r="6"
      fill="black"
    ></circle>
    <circle
      cx="6"
      cy="47"
      r="6"
      fill="black"
    ></circle>
    <circle
      cx="47"
      cy="47"
      r="11"
      fill="black"
    ></circle>
    <circle
      cx="27"
      cy="27"
      r="11"
      fill="black"
    ></circle>
    <circle
      cx="27"
      cy="47"
      r="11"
      fill="black"
    ></circle>
  </svg>
</template>

<style scoped></style>
